import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { setAddExtricationToTimeline } from '../store/quickActions.actions'
import { resetState } from '../../procedures/extrication/store/extrication.actions'
import { addExtricationItem } from '../../timeline/store/timeline.actions'
import { ExtricationConstants } from '../../procedures/extrication/store/extrication.constants'

export function* saveExtricationQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addExtricationToTimeline } = quickActionsObject
  if (addExtricationToTimeline) {
    yield put(addExtricationItem())
    yield put(setAddExtricationToTimeline(false))
    yield put(resetState())
  }
}

export function* saveExtricationQuickActionTimeLineRowSaga() {
  yield takeLatest([ExtricationConstants.SET_ADD_TO_TIMELINE], saveExtricationQuickActionTimeLineRow)
}
